const getStorage = (storageType = 'local') => {
    return storageType === 'local' ? localStorage : sessionStorage;
}

export const saveToStorage = (key, value, storageType) => {
    const storage = getStorage(storageType);
    storage.setItem(key, JSON.stringify(value));
}

export const readFromStorage = (key, storageType) => {
    try {
        const storage = getStorage(storageType);
        const value = storage.getItem(key);
        return value ? JSON.parse(value) : null;
    } catch (e) {
        return null;
    }
}

export const removeFromStorage = (key, storageType) => {
    const storage = getStorage(storageType);
    storage.removeItem(key);
}